import React from 'react';
import ServiceList from './ServiceList';
import { ButtonGroup, Button } from 'react-bootstrap';
import * as API from 'modules/app/API.js';
import * as Help from 'modules/app/Help'

class ServicesTab extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
		return {
			services: [],
			pings: []
		}
	}

	onPing = (serviceName) => {
		this.pingSingleService(serviceName);
	}

	updatePing = (newPing) => {
		this.setState({
			pings: this.state.pings.map(existingPing => existingPing.serviceName === newPing.serviceName ? newPing : existingPing)
		});
	}

	pingSingleService = (serviceName) => {
		const me = this;

		API.App.post('/console/pingService', { serviceName },
			{
				success: (sr) => {
					const newPing = Object.assign(sr.data || {}, { serviceName: serviceName, pingError: null, processing: false });
					console.log("PING OK " + serviceName, newPing);
					me.updatePing(newPing);
				},
				error: (sr) => {
					const newPing = { serviceName: serviceName, pingError: sr.error, processing: false };
					me.updatePing(newPing);
					console.log("PING ERROR " + serviceName, newPing);
				}
			});
	}

	onPingServices = () => {
		const me = this;
		const services = this.state.services;
		const pings = services.map(function (s) { return { serviceName: s.serviceName, processing: true, pingError: null } });

		// Reset state
		const reset = {
			services: services,
			pings: pings
		}

		// Clear all pings
		this.setState(reset, function () {
			// Ping all services
			services.forEach(function (s) {
				me.pingSingleService(s.serviceName);
			});
		});
	}

	setHelp = () => {
        if (this.props.helpKey)
            Help.setHelp(this.props.helpKey)
        else
            Help.clearHelp();
    }

	componentDidMount() {
		var rq = {};
		var me = this;

		API.App.get('/console/getServices', rq,
			{
				success: (sr) => {
					this.setState({ services: sr.data.items }, function () {
						me.onPingServices();
					});
				}
			});

		this.setHelp();
	}

	render() {
		return (
			<React.Fragment>
				<ServiceList
					services={this.state.services}
					pings={this.state.pings}
					onPing={this.onPing} />
				<hr />
				<div className="text-center">
					<ButtonGroup>
						<Button onClick={this.onPingServices} bsStyle="success">Ping Services</Button>
					</ButtonGroup>
				</div>
			</React.Fragment>)
	}
}

export default ServicesTab;



// WEBPACK FOOTER //
// ./src/areas/admin/console/services/ServicesTab.js